/**
 * Masking utilities for sensitive data display
 * Used to obscure PII during demos and public presentations
 */

/**
 * Masks an email address, showing only first 2 chars and domain
 * e.g., "john.doe@example.com" → "jo***@example.com"
 */
export function maskEmail(email: string): string {
  const [local, domain] = email.split('@')
  if (!domain || local.length <= 2) return email
  return `${local.slice(0, 2)}***@${domain}`
}

/**
 * Masks a phone number, showing first 3 and last 2 digits
 * e.g., "555-123-4567" → "555-***-**67"
 */
export function maskPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '')
  if (digits.length < 6) return '***-***-****'
  return `${digits.slice(0, 3)}-***-**${digits.slice(-2)}`
}

/**
 * Masks a name, showing first 2 characters
 * e.g., "Johnson" → "Jo****"
 */
export function maskName(name: string): string {
  if (name.length <= 2) return name
  return `${name.slice(0, 2)}${'*'.repeat(Math.min(name.length - 2, 4))}`
}
